<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div>
  <div class="control-row">
    <label class="title">Chr</label>
    <app-dropdown
      class="chr-dropdown"
      [label]="''"
      [options]="dropdownOptions"
      (selectedValueChange)="handleChrChange($event)"
      [selectedValue]="selectionValue"
      [formControlObj]="selectPanelName"
    ></app-dropdown>
  </div>
  <div class="control-row">
    <label class="title">Total</label>
    <mat-form-field appearance="outline" class="total">
      <input
        matInput
        [value]="total"
        readonly
        aria-readonly="true"
      />
    </mat-form-field>
  </div>
</div>
<div echarts
  class="chart"
  [options]="chartOption"
  [merge]="mergeOption"
  [style.width]="width"
  [style.height]="height"
></div>
